import { render, staticRenderFns } from "./form-confime-from-shop.vue?vue&type=template&id=35f7596f&"
import script from "./form-confime-from-shop.vue?vue&type=script&lang=js&"
export * from "./form-confime-from-shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports